import React from 'react';
import { useForm } from 'react-hook-form';
import api from '../services/api';

const CycleModal = ({ show, onClose, onCreated }) => {
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const onSubmit = async (data) => {
    try {
      await api.post('/cycles', data);
      onCreated && onCreated();
      reset();
      onClose();
    } catch (e) {
      alert("Erreur lors de l'ajout du cycle");
    }
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <h2 className="text-lg font-semibold mb-4">Ajouter un cycle</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Nom du cycle *</label>
            <input
              type="text"
              {...register('cycle', { required: true })}
              className="block w-full rounded-lg border border-gray-300 px-3 py-2"
            />
            {errors.cycle && <span className="text-red-500 text-xs mt-1">Champ obligatoire</span>}
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
            <input
              type="text"
              {...register('description')}
              className="block w-full rounded-lg border border-gray-300 px-3 py-2"
            />
          </div>
          <div className="flex justify-end space-x-2 mt-6">
            <button type="button" className="px-4 py-2 bg-gray-200 rounded-lg" onClick={onClose}>Annuler</button>
            <button type="submit" className="px-4 py-2 bg-primary-600 text-white rounded-lg">Ajouter</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CycleModal;
